import { s_r_e as lang } from '~/lang/ru';

export const ServiceRequestDeviceInfo = {
	functional: true,
	props: {
		device: Object,
	},
	render(h, { props }) {
		return (
			<div>
				<p>
					<b>{ lang('BRAND') }:</b> { props.device.brand }
				</p>
				<p>
					<b>{ lang('MODEL') }:</b> { props.device.model }
				</p>
				<p>
					<b>{ lang('SERIAL_NUMBER') }:</b> { props.device.serialNumber }
				</p>
				<p>
					<b>{ lang('DEFECT') }:</b> { props.device.defect }
				</p>
			</div>
		);
	},
}
